import { Link } from "react-router-dom";
import { ArrowLeft, ArrowRight } from "lucide-react";
import { useOrderMenu } from "@/hooks/useOrderMenu";
import CartBar from "@/components/CartBar";
import { catSlug } from "@/utils/menu";

export default function OrderPage() {
  const { menu, accepting } = useOrderMenu();

  return (
    <div className="min-h-screen pt-16 pb-32" data-testid="order-page">
      <header className="max-w-5xl mx-auto px-6 pt-10 pb-8 border-b-2 border-zinc-800">
        <a href="/" className="inline-flex items-center gap-2 border-2 border-zinc-700 bg-white hover:border-ember px-6 py-3.5 font-mono font-bold text-sm tracking-wide uppercase text-ink hover:text-ember transition-colors duration-300 mb-6" data-testid="order-back-home">
          <ArrowLeft className="w-5 h-5" /> Back to home
        </a>
        <h1 className="font-display text-6xl sm:text-7xl leading-none uppercase text-gold-shine" data-testid="order-page-heading">Order Online</h1>
        <p className="mt-3 font-mono text-sm tracking-[0.2em] uppercase text-zinc-500">Pay online · Pickup in store · Pick a category to start</p>
        <p className="mt-2 font-mono text-sm font-bold tracking-[0.15em] uppercase text-ember" data-testid="order-pickup-note">
          Pickup only — for delivery, order via Uber Eats, DoorDash or Menulog
        </p>
      </header>

      {!accepting && (
        <div className="max-w-5xl mx-auto px-6 mt-6" data-testid="ordering-paused-banner">
          <p className="border border-ember bg-ember/10 text-ember font-mono text-xs tracking-[0.15em] uppercase px-4 py-3">
            Online ordering is paused right now — please call (03) 5024 5570 to order
          </p>
        </div>
      )}

      <main className="max-w-5xl mx-auto px-6 pt-10">
        {!menu && <p className="font-mono text-sm text-zinc-500">Loading menu…</p>}
        <div className="grid sm:grid-cols-2 gap-4" data-testid="category-hub">
          {menu?.categories.map((c) => {
            const items = menu.items.filter((i) => i.category === c);
            const from = Math.min(...items.map((i) => (i.sizes ? Math.min(...Object.values(i.sizes)) : i.price)));
            return (
              <Link
                key={c}
                to={`/order/c/${catSlug(c)}`}
                data-testid={`hub-cat-${catSlug(c)}`}
                className="group border-2 border-zinc-700 bg-white hover:border-ember p-6 flex items-center justify-between gap-4 transition-colors duration-300"
              >
                <div>
                  <h2 className="font-display text-4xl uppercase tracking-wide group-hover:text-ember transition-colors duration-300">{c}</h2>
                  <p className="mt-1 font-mono text-xs tracking-[0.2em] uppercase text-zinc-500">
                    {items.length} item{items.length > 1 ? "s" : ""} · from ${from}
                  </p>
                </div>
                <ArrowRight className="w-6 h-6 text-zinc-500 group-hover:text-ember group-hover:translate-x-1 transition-[transform,color] duration-300 shrink-0" />
              </Link>
            );
          })}
        </div>
      </main>

      <CartBar />
    </div>
  );
}
